import { useEventManager } from '@deathbyjer/react-event-manager'
import { checkIncompleteField, useDataTemplate } from 'components/form_builder/features/data/dataSlice'
import React, { useCallback, useMemo } from 'react'
import useSelectedKeys from '../../hooks/useSelectedKeys'
import { useDispatch } from 'react-redux'
import { setActive } from 'components/form_builder/features/tools/toolSlice'

const Item = ({ component, activeTool, iconClassName = 'fa-light fa-credit-card-blank' }) => {
  const dispatch = useDispatch()
  const selectedKeys = useSelectedKeys()
  const events = useEventManager()
  const template = useDataTemplate(component.type, component.id)
  const isIncompleteField = useMemo(() => checkIncompleteField(component.type, template), [template, component.type])

  const handleClick = useCallback(() => {
    dispatch(setActive('select'))
    setTimeout(() => {
      events.applyEventListeners('selectComponent', component.keyArray)
      events.applyEventListeners(`scrollToField`, component.page)
    }, 0);
  }, [component.keyArray, component.page, events])

  return (
    <div
      onClick={handleClick}
      style={{ backgroundColor: isIncompleteField ? '#E4F2F5' : '' }}
      className={`item field ${selectedKeys.includes(component.key) ? 'active' : ''}`}
    >
      <div className="dome-full-width dome-d-flex dome-gap12 dome-align-center dome-justify-between">
        <div className="dome-d-flex dome-gap12">
          <div className="icon">
            <i className={iconClassName}></i>
          </div>
          <div className="field-name">
            <p>{component.label}</p>
          </div>
        </div>
        {isIncompleteField && (
          <span>
            <i className="fa-light fa-circle-exclamation dome-color-lite-grey"></i>
          </span>
        )}
      </div>
    </div>
  )
}

export default Item
